// The api slice needs to redirect to the login screen when a request
// comes back 401, but baseQuery runs outside React. WarehouseApp stores
// its navigate function here on mount so the 401 handler can use SPA
// navigation - a full page navigation would drop the BigCommerce
// signed_payload query param and break the app shell.
let navigateRef = null;

export function setWarehouseNavigate(navigate) {
  navigateRef = navigate;
}

export function navigateToLogin() {
  if (navigateRef) {
    navigateRef('/warehouse/app/login?expired=1', { replace: true });
  }
}
